import type { LocaleMessageBundle } from '../../types'

export const buttons: LocaleMessageBundle = {
  vi: {
    'button.show': 'Hiện mật khẩu',
    'button.hide': 'Ẩn mật khẩu',
    'button.toggleTheme': 'Đổi giao diện sáng/tối',
    'button.save': 'Lưu',
    'button.cancel': 'Đóng',
    'button.confirm': 'Xác nhận',
    'button.close': 'Đóng',
    'button.delete': 'Xóa',
    'button.edit': 'Chỉnh sửa',
    'button.add': 'Thêm mới',
    'button.addShort': 'Thêm',
    'button.update': 'Cập nhật',
    'button.retry': 'Thử lại',
    'button.refresh': 'Làm mới',
    'button.yes': 'Có',
    'button.no': 'Không',
    'button.restore': 'Khôi phục',
    'button.print': 'In',
    'button.increase': 'Tăng số lượng',
    'button.decrease': 'Giảm số lượng',
    'button.preview': 'Xem trước',
    'button.settings': 'Cài đặt',
    'button.note': 'Ghi chú',
    'button.expand': 'Mở rộng',
    'button.collapse': 'Thu gọn',
    'button.resetPassword': 'Đặt lại mật khẩu',
    'button.autoGenerate': 'Tự động tạo',
    'button.help': 'Trợ giúp',
    'button.cancelVoucher': 'Hủy',
    'button.complete': 'Hoàn thành',
    'button.addTab': 'Thêm tab',
    'button.closeTab': 'Đóng tab',
  },
  en: {
    'button.show': 'Show password',
    'button.hide': 'Hide password',
    'button.toggleTheme': 'Toggle light/dark theme',
    'button.save': 'Save',
    'button.cancel': 'Cancel',
    'button.confirm': 'Confirm',
    'button.close': 'Close',
    'button.delete': 'Delete',
    'button.edit': 'Edit',
    'button.add': 'Add new',
    'button.addShort': 'Add',
    'button.update': 'Update',
    'button.retry': 'Retry',
    'button.refresh': 'Refresh',
    'button.yes': 'Yes',
    'button.no': 'No',
    'button.restore': 'Restore',
    'button.print': 'Print',
    'button.increase': 'Increase quantity',
    'button.decrease': 'Decrease quantity',
    'button.preview': 'Preview',
    'button.settings': 'Settings',
    'button.note': 'Note',
    'button.expand': 'Expand',
    'button.collapse': 'Collapse',
    'button.resetPassword': 'Reset password',
    'button.autoGenerate': 'Auto generate',
    'button.help': 'Help',
    'button.cancelVoucher': 'Cancel voucher',
    'button.complete': 'Complete',
    'button.addTab': 'Add tab',
    'button.closeTab': 'Close tab',
  },
}
